import styled from "styled-components";
import {
  LOGO_HOME,
} from "@assets";

export const Bar = styled.div`
  height: 70px;
  padding-inline: 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: ${props => props.theme.appbarColor};
  z-index: 1000;
`;

export const LogoWrapper = styled.div`
flex: 1;
display: flex;
gap: 5px;
align-items: flex-end;
justify-content: flex-start;
`;

export const Logo = styled(LOGO_HOME)``;

export const IconsWrapper = styled.div`
display: flex;
gap: 8px;
align-items: center;
justify-content: center;

svg {
  cursor: pointer;
}

@media screen and (max-width: 320px) {
gap: 6px;

  svg {
    width: 20px;
  }
}
`;

export const Icon = styled.div`
display: flex;
gap: 4px;
align-items: center;
justify-content: center;
padding: 4px 8px;
border-radius: 8px;
background-color: #212224;
cursor: pointer;

@media screen and (max-width: 320px) {
  padding: 3px 6px;
}
`;

export const Text = styled.div`
color: #FFF;
font-size: 14px;
font-style: normal;
font-weight: 100;
line-height: 1.5;

@media screen and (max-width: 320px) {
font-size: 13px;
}
`;